export default __webpack_public_path__ + "static/media/twitter.a70d7373.svg";